import { useCallback, useMemo } from 'react'
import { AlertTriangle } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchErrors, AUTO_STR as S, type AutomationErrorRow } from './automationApi'

/**
 * A26.06 — Ошибки выполнения (failed workflow runs, read-only). Dormant until
 * `/admin/automation/errors` ships. Placeholder permission USERS_VIEW.
 */
export function ErrorsScreen() {
  const columns = useMemo<AdminColumn<AutomationErrorRow>[]>(
    () => [
      { key: 'workflow', header: S.workflow, type: 'text' },
      { key: 'error', header: S.error, type: 'text' },
      { key: 'occurred_at', header: S.occurredAt, type: 'text' },
      { key: 'count', header: S.count, type: 'number' },
    ],
    [],
  )
  const fetcher = useCallback(fetchErrors, [])
  return (
    <>
      <PageHeader title={S.errors} screenId="A26.06" />
      <DataTable<AutomationErrorRow>
        screenId="A26.06"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <AlertTriangle size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
